<script setup lang="ts">
import { GrammarBadge, GrammarSwitch } from '@nora-monorepo/grammar-ui';

import { useMapStore } from '#nora-ui/map/stores/map-store';

const props = defineProps<{
  mapId: string;
}>();
const { mapId } = props;

const mapStore = useMapStore();

const map = mapStore.getMapByIdOrThrow(mapId);

const allLayersVisible = map.state.draw.areAllDrawLayersVisible;
</script>

<template>
  <div class="flex justify-between">
    <div class="flex items-center">
      <GrammarBadge
        label="Display all layers"
        :emphasis="allLayersVisible ? 'no-background-high' : 'no-background'"
      />
    </div>
    <div>
      <GrammarSwitch
        :selected="allLayersVisible"
        @change="map.state.draw.toggleAllDrawLayersVisibility()"
      />
    </div>
  </div>
</template>
